<template>
  
  <v-card
  class="mx-auto text-white mt-5 card-container"
  color="white"
  max-width="340"
  height="500"
>

  <div class="new-card-header"  :style="{
    backgroundImage: `url(${project.backgroundImageUrl})`
  }">

  </div>


  <v-card-title class="new-card-title"   :style="{ color: 'black'}">
    {{project.title}}
  </v-card-title>

  <v-card-text class="py-2 description-text-card-1"  :style="{ color: 'black'}">
      {{project.description}}
  </v-card-text>

  <v-card-text class="py-2 description-text-card">
  
    <div class="price-container">
      
      <div v-for="(priceItem, index) in project.priceItems" :key="'price' + index" class="price-box"  :style="{ background: project.bgColor}">
        <div class="price-title">{{ priceItem.number }} cans</div>
        <div class="price-value">€ {{ priceItem.price }}</div>
      </div>


    </div>

    <div @click="$emit(`buyNow`)" class="buy-container">
      <v-btn class="buy-button">
        BUY NOW
      </v-btn>
    </div>

  </v-card-text>

</v-card>


</template>
  
  <script>
  export default {
    name: 'KuhulCardProduct',
    data: () => ({
     
    }),
    props: {
      project: {
        type : Object,
        required: true
      }
    },
    async mounted(){
      
    },
    methods : {
    
    }
  }
  </script>
  
  <style scoped>

  *:focus {
    outline: none;
  }

  .description-text-card-1{
    height: auto;
    font-family: 'DM Sans', sans-serif !important;
    font-size: 15px;
    font-weight: 500;
  }

  .card-container{
    height: 550px !important;
    padding:20px;
    margin-right: 40px !important;
    border-radius: 20px;
  }
  .new-card-title{
    margin-top:10px;
    font-size: 40px;
    font-family: 'Poppins', sans-serif !important;
    font-weight: bolder;
  }

  .new-card-header{
    height: 40%;
    background-size: cover;   
    background-position: center; 
    background-repeat: no-repeat; 
  }




  .v-chip {
    background-color: white !important;
    
  
  }
  .v-chip__content {
    background-color: white !important;
    
    
  }

  .p-chip{
    color:black !important;
    font-weight: bold;
  }
 

  .description-text-card {
     height: 120px; 
    display: flex;
    justify-content: space-between;
    align-items: center;
  }


.price-container {
  display: flex;
  gap: 15px;
  z-index: 2;
   height: 100px; 
}

.price-box {
  width: 90px;
  height: 90px;
  margin-bottom: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Poppins', sans-serif !important;
  color: white;
}

.price-title {
  font-size: 12px;
  color: white;
}

.price-value {
  font-size: 16px;
  font-weight: bold;
}

.buy-container {

  align-items: center;
  height: 80px;
}

.buy-button {
  transform: rotate(-90deg);
  font-weight: bold;
  letter-spacing: 2px;
}

  </style>
  